var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_406_13827)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8335 18C22.1391 18 18.3335 21.8056 18.3335 26.5C18.3335 31.1944 22.1391 35 26.8335 35C28.8203 35 30.6479 34.3183 32.0952 33.1761L36.6262 37.7071C37.0167 38.0976 37.6499 38.0976 38.0404 37.7071C38.4309 37.3166 38.4309 36.6834 38.0404 36.2929L33.5094 31.7619C34.6518 30.3146 35.3335 28.4869 35.3335 26.5C35.3335 21.8056 31.5279 18 26.8335 18ZM31.4941 31.0309C32.6325 29.8601 33.3335 28.2619 33.3335 26.5C33.3335 22.9101 30.4233 20 26.8335 20C23.2436 20 20.3335 22.9101 20.3335 26.5C20.3335 30.0899 23.2436 33 26.8335 33C28.5954 33 30.1935 32.299 31.3642 31.1607C31.3837 31.1374 31.4043 31.1148 31.4262 31.0929C31.4481 31.071 31.4707 31.0503 31.4941 31.0309Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_13827",
    x1: 4.51006,
    y1: 1.48605e-7,
    x2: 56.104,
    y2: 54.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B42196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52502,
    stopColor: "#6D85EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08AABC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.45fc50e59a0a1dbee2a617bda400a1e4.svg";
export { ForwardRef as ReactComponent };